import DetailsCardThreeColumnRow from "@/components/DetailsCardThreeColumnRow";
import {
  CardSkeleton,
  ChartSkeleton,
  ListItemSkeleton,
  MetricGridSkeleton,
  SectionHeadingSkeleton
} from "@/components/Skeleton";

export default function ExperienceIndexResultsSkeleton() {
  return (
    <div data-testid="career-plan-ei-results-skeleton">
      <SectionHeadingSkeleton />
      <CardSkeleton className="w-full" width={100} rows={4} />
      <SectionHeadingSkeleton />
      <MetricGridSkeleton layout="thirds" hasHeading cards={3} />
      <SectionHeadingSkeleton />
      <div className="flex flex-col gap-6 lg:flex-row lg:items-start">
        <ListItemSkeleton className="w-full shrink-0 lg:w-80" rows={5} />
        <div className="flex min-w-0 flex-1 flex-col gap-6">
          <ChartSkeleton type="radar" />
          <ListItemSkeleton rows={5} />
        </div>
      </div>
      <SectionHeadingSkeleton />
      <DetailsCardThreeColumnRow>
        <CardSkeleton className="h-full w-full" width={100} rows={4} />
        <CardSkeleton className="h-full w-full" width={100} rows={4} />
        <CardSkeleton className="h-full w-full" width={100} rows={4} />
      </DetailsCardThreeColumnRow>
    </div>
  );
}
